import './NavBar.scss';
import { ReactNode } from 'react';
import { MdLogout } from 'react-icons/md';
import { useLogout } from '../../redux/user';
import { Appearance, Background } from '../designConstants';
import { IconButton } from '../IconButton';

export const LogOut = (): ReactNode => {
  const logout = useLogout();
  return (
    <IconButton
      data-testid='nav-log-out'
      className='nav-log-out'
      appearance={Appearance.EMPTY}
      background={Background.DARK}
      onClick={logout}
    >
      <MdLogout color='white' />
    </IconButton>
  );
};
